import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import classNames from 'classnames/dedupe';

import {
    Transition,
    transitionConfigs
} from 'cstar-react-primitives/lib/redux-form/animate/Transition';
import { ButtonWrapper } from 'cstar-react-primitives/lib/redux-form/buttons/ButtonWrapper';
import { icons } from 'cstar-react-primitives/lib/redux-form/icons/iconConst';
import { getPaidCardsCount } from '../item/itemSelectors';
import cartMessages from './cartMessages';



export const CardCount = ({ number }) => {
    const iconClass = classNames('card-count', {
        'card-count--md': number > 9 && number < 100,
        'card-count--lg': number > 99
    });

    return (
        <Transition config={transitionConfigs.popConfig}>
            { number > 0 && <span className={iconClass} key={`icon-${number}`}>{number}</span> }
        </Transition>
    );
};

CardCount.propTypes = {
    number: PropTypes.number.isRequired
};


export const CartIcon = (props) => {
    const { numberOfCards, clickHandler, intl } = props;
    const cashbotName = 'cart-link';
    const cartIconProps = {
        cashbotName,
        ariaLabel: intl.formatMessage(cartMessages.cartIconLabel),
        cssClass: 'cart-icon',
        onClick: clickHandler
    };
    return (
        <ButtonWrapper {...cartIconProps}>
            {icons.CART_ICON}
            <CardCount number={numberOfCards} />
        </ButtonWrapper>
    );
};

CartIcon.defaultProps = {
    numberOfCards: 0
};

CartIcon.propTypes = {
    intl: intlShape.isRequired,
    clickHandler: PropTypes.func.isRequired,
    numberOfCards: PropTypes.number
};

const mapStateToProps = state => ({
    numberOfCards: getPaidCardsCount(state)
});


export default connect(mapStateToProps)(injectIntl(CartIcon));
